<template>
  <div class="space-y-6">
    <div class="border rounded-lg p-6 space-y-6 mb-3">
      <b-row
        align-v="center"
        class="text-black"
      >
        <b-col cols="3">
          Upload Label Pengiriman*
        </b-col>
        <b-col cols="4">
          <b-form-file
            v-model="file1"
            placeholder="Pilih file..."
            drop-placeholder="Taruh file di sini..."
            accept="application/pdf"
            @change="handleContentIsUpdated({
              completed: warehouse && !somePacketTypeNotSaved(),
            })"
          />
        </b-col>
        <b-col cols="3">
          <b-button
            v-if="file1"
            variant="outline-primary"
            @click="previewFile()"
          >
            Preview
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div class="space-y-6">
      <b-row
        align-v="center"
        class="text-black"
      >
        <b-col
          cols="12"
          md="3"
          class="mb-2 mb-md-0"
        >
          Pilih Mitra Gudang
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <infinite-select
            v-model="tempWarehouse"
            placeholder="Pilih gudang pengajuan packing"
            class="flex-1 bg-white"
            option-label="name"
            :options="warehouseOptions"
            :has-next-page="fetcherWarehouses.hasMore"
            :debounce-timeout="500"
            :loading="fetcherWarehouses.isLoading"
            :clearable="false"
            @on-search="handleSearchWarehouse"
            @on-intersect="fetcherWarehouses.fetchData()"
          >
            <template #no-options="{ search, searching }">
              <template v-if="searching">
                Gudang <em>'{{ search }}'</em> tidak ditemukan.
              </template>
              <em v-else>Masukan nama gudang yang valid</em>
            </template>
          </infinite-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div
            class="flex rounded-lg bg-[#DFF3FF] px-3.5 py-2.5 gap-2.5 items-start"
          >
            <img
              src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
              alt="info-circle"
            >
            <div class="text-[#333]">
              Yuk buat rangkuman ordermu. Kamu hanya perlu input rangkuman
              orderanmu ya dengan cara input jenis isi paket dan jumlah
              ordernya.
              <a
                href="https://www.youtube.com/watch?v=TqIfZ1DMVh4&t"
                target="_blank"
                class="text-[#08A0F7] underline hover:text-[#08A0F7]"
              >Lihat Tutorial</a>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- <BulkUploadComponent
            v-if="isAllowedForBulkUpload"
            ref="bulkUploadComponent"
            :raw-products-cache="rawProductsCache"
            :packing-options="packings.options"
            :packing-options-object="packings.optionsObj"
            :disable-bulk-upload="!enableForContentAddition"
            :partner-id="userData ? userData.partner_detail.id : 0"
            :warehouse-id="warehouse && warehouse.id"
            :mitra-id="warehouse && warehouse.mitra_id"
            :is-uploading-label="isUploadingLabel"
            @bulk-data-success="handleBulkDataSuccess"
            @content-is-updated="handleContentIsUpdated"
          /> -->
        </b-col>
      </b-row>
      <b-row
        v-if="!bulkDataShown"
      >
        <b-col class="text-[#333] space-y-6">
          <div
            v-for="(packet, index0) in packetType"
            :key="index0"
            class="border rounded-lg p-6 space-y-4"
          >
            <div class="flex justify-between border-b pb-[16px]">
              <div>
                Jenis Paket {{ index0 + 1 }}
              </div>
              <div class="flex gap-[12px]">
                <b-button
                  v-if="packet.saved && index0 === packetType.length - 1"
                  size="sm"
                  variant="primary"
                  :disabled="confirmButton"
                  @click="handleEditPacket(packet)"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/edit.svg"
                    width="13"
                    alt="edit"
                  >
                </b-button>
                <b-button
                  v-if="packet.saved && index0 === packetType.length - 1 && packetType.length > 1"
                  size="sm"
                  variant="primary"
                  :disabled="confirmButton"
                  @click="packetType.splice(index0, 1),
                          updateProductMap(packet, 'increase'),
                          tellThatPacketIsUpdated()"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/trash.svg"
                    width="13"
                    alt="trash"
                  >
                </b-button>
                <b-button
                  v-if="!packet.saved && !packet.total"
                  size="sm"
                  variant="outline-primary"
                  :disabled="confirmButton"
                  @click="handleLastItemRemoval(), packetType.splice(index0, 1)"
                >
                  Hapus
                </b-button>
                <b-button
                  v-if="!packet.saved"
                  size="sm"
                  :variant="addPacketContentDisabled(packet) || !packet.total || packet.total > packet.maxTotal || confirmButton ? 'secondary' : 'primary'"
                  :disabled="addPacketContentDisabled(packet) || !packet.total || packet.total > packet.maxTotal || confirmButton"
                  @click="handleRecalculation(packet, index0)"
                >
                  {{ packet.isLoading ? 'Menyimpan...' : 'Simpan' }}
                </b-button>
              </div>
            </div>
            <div class="overflow-x-auto">
              <!-- Label -->
              <div class="flex mb-[8px] min-w-[1000px]">
                <b-col
                  cols="3"
                  class="!pl-0"
                >
                  <div for="packet-product-id">
                    Isi Paket
                  </div>
                </b-col>
                <b-col cols="3">
                  <div for="packet-product-id">
                    Variasi
                    <img
                      v-b-tooltip.hover.top="'Variasi tidak dapat dipilih jika stok kosong'"
                      src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                      alt="info-circle"
                      class="inline-flex"
                      width="16"
                    >
                  </div>
                </b-col>
                <b-col cols="2">
                  <div for="packet-product-id">
                    Jumlah Item
                    <img
                      v-b-tooltip.hover.top="'Jumlah item produk dalam satu paket'"
                      src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                      alt="info-circle"
                      class="inline-flex"
                      width="16"
                    >
                  </div>
                </b-col>
                <b-col cols="2">
                  <div for="packet-product-id">
                    Jumlah Order
                    <img
                      v-b-tooltip.hover.top="'Total jumlah paket dengan isi yang sama'"
                      src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                      alt="info-circle"
                      class="inline-flex"
                      width="16"
                    >
                  </div>
                </b-col>
                <b-col
                  cols="2"
                  class="!pr-0"
                >
                  <div
                    id="bahan-packing-label"
                    for="bahan-packing"
                  >
                    Bahan Packing
                  </div>
                </b-col>
              </div>
              <!-- Fields -->
              <div
                v-for="(item, index1) in packet.packetContent"
                :key="index1"
              >
                <div
                  class="flex mb-[8px] min-w-[1000px] text-[14px]"
                >
                  <!-- Isi Paket -->
                  <b-col
                    cols="3"
                    class="!pl-0"
                  >
                    <infinite-select
                      v-model="item.option"
                      placeholder="Pilih Isi Paket"
                      class="flex-1 bg-white"
                      option-label="label"
                      append-to-body
                      :calculate-position="positionDropdown"
                      :disabled="packet.saved || confirmButton"
                      :options="productManagementsData"
                      :has-next-page="productManagementsHasMore"
                      :debounce-timeout="500"
                      :loading="productManagementsLoading"
                      :clearable="false"
                      @on-search="onSearchProduct"
                      @on-intersect="onIntersectProduct"
                      @input="updatePacketContent(packet, item)"
                      @option:selected="handlePacketChange"
                    >
                      <template #no-options="{ search, searching }">
                        <template v-if="searching">
                          Produk <em>'{{ search }}'</em> tidak ditemukan.
                        </template>
                        <em v-else>Masukan nama produk yang valid</em>
                      </template>
                    </infinite-select>
                  </b-col>
                  <!-- Variasi -->
                  <b-col cols="3">
                    <div v-if="item.option">
                      <!-- Product non-bundling -->
                      <div v-if="!item.option.is_bundling">
                        <v-select
                          v-model="item.variants[0]"
                          :options="item.option.variants"
                          :reduce="option => option"
                          :selectable="checkIsSelectableVariant"
                          :clearable="false"
                          :disabled="packet.saved || confirmButton"
                          :label="item.option.is_variant ? 'name' : 'label'"
                          append-to-body
                          :calculate-position="positionDropdown"
                          placeholder="Pilih Variasi"
                          @input="removeSameVariant(packet.packetContent),
                                  updateAvailable(item, 0, item.amount)"
                        />
                      </div>
                      <!-- Product bundling -->
                      <div
                        v-if="item.option.is_bundling"
                        class="space-y-5"
                      >
                        <div
                          v-for="(bundling, index2) in item.option.variants"
                          :key="index2"
                          class="space-y-5"
                        >
                          <div
                            v-for="qty in bundling.qty"
                            :key="qty"
                          >
                            <v-select
                              v-if="bundling.bundling_variants.length > 0"
                              v-model="item.variants[getBundlingVariantIndex(item.option.variants, index2, qty)]"
                              :options="bundling.bundling_variants"
                              :placeholder="bundling.product_name"
                              label="name"
                              :disabled="packet.saved || confirmButton"
                              :clearable="false"
                              :selectable="(option) => checkIsSelectableVariant(option, qty)"
                              append-to-body
                              :calculate-position="positionDropdown"
                              @input="updateAvailable(item, index2, qty),
                                      removeSameVariant(packet.packetContent)"
                            />
                            <v-select
                              v-else
                              v-model="item.variants[getBundlingVariantIndex(item.option.variants, index2, qty)]"
                              :options="[{ id: 0, product_id: bundling.product_id, name: bundling.product_name, stock: bundling.stock, qty: bundling.qty, label: bundling.product_name + ' : -', is_product_bonus: bundling.is_product_bonus}]"
                              :placeholder="bundling.product_name"
                              :disabled="packet.saved || confirmButton"
                              :clearable="false"
                              :selectable="(option) => checkIsSelectableVariant(option, qty)"
                              append-to-body
                              :calculate-position="positionDropdown"
                              @input="updateAvailable(item, index2, qty),
                                      removeSameVariant(packet.packetContent)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <v-select
                      v-else
                      placeholder="Pilih Isi Paket Dulu"
                      disabled
                    />
                  </b-col>
                  <!-- Jumlah Item -->
                  <b-col cols="2">
                    <b-form-input
                      v-model="item.amount"
                      :disabled="packet.saved || !item.option || confirmButton"
                      :formatter="formatNumber"
                      number
                      @input="packet.total = null, setMaxAmount(item, item.variants)"
                      @change="item.amount < 1 ? item.amount = 1 : item.amount"
                    />
                  </b-col>
                  <!-- Jumlah Order -->
                  <b-col cols="2">
                    <b-form-input
                      v-if="index1 === 0"
                      v-model="packet.total"
                      :disabled="packet.saved || addPacketContentDisabled(packet) || confirmButton"
                      :formatter="formatNumber"
                      number
                    />
                    <div
                      v-if="index1 === 0 && !packet.saved"
                      class="mt-[4px] text-[12px] absolute"
                    >
                      <span
                        v-b-tooltip.hover.top="'Stok tersedia untuk membuat kombinasi jenis order'"
                        class="text-primary"
                      >Tersedia:</span>
                      <span v-if="!addPacketContentDisabled(packet)">
                        {{ packet.maxTotal = item.available }}
                      </span>
                      <span v-else>
                        -
                      </span>
                    </div>
                  </b-col>
                  <!-- Bahan Packing -->
                  <b-col
                    cols="2"
                    class="!pr-0"
                  >
                    <div
                      v-if="index1 === 0"
                      class="border rounded-lg p-[8px]"
                    >
                      <PackingSelection v-model="packet.packings" />

                      <b-button
                        size="sm"
                        variant="ghost"
                        class="w-full !text-left !px-[4px] !font-normal"
                        :class="addPacketContentDisabled(packet) || packet.saved || confirmButton ? '!text-[#636363]' : '!text-[#F95031]'"
                        :disabled="addPacketContentDisabled(packet) || packet.saved || confirmButton"
                        @click="handleEditPacking(packet, index0)"
                      >
                        <span class="k-add text-[14px]" />
                        Bahan Packing
                      </b-button>
                    </div>
                  </b-col>
                </div>
              </div>
            </div>
            <!-- Button tambah isi paket -->
            <b-row>
              <b-col class="space-x-4">
                <b-button
                  v-if="!packet.saved"
                  size="sm"
                  :variant="addPacketContentDisabled(packet) ? 'outline-secondary' : 'outline-primary'"
                  :disabled="addPacketContentDisabled(packet) || confirmButton"
                  @click="pushEmptyPacketContent(packet, index0), packet.total = null"
                >
                  Tambah Isi Paket
                </b-button>
                <b-button
                  v-if="!packet.saved && packet.packetContent.length > 1"
                  size="sm"
                  variant="outline-primary"
                  :disabled="confirmButton"
                  @click="packet.packetContent.splice(packet.packetContent.length - 1, 1)"
                >
                  Hapus Isi Paket
                </b-button>
              </b-col>
            </b-row>
          </div>
          <div class="border-[1px] border-dashed border-[#E2E2E2] rounded-lg p-[16px]">
            <b-button
              :variant="somePacketTypeNotSaved() ? 'secondary' : 'primary'"
              :disabled="somePacketTypeNotSaved() || confirmButton"
              @click="setOrEmptyPacketType(false)"
            >
              Tambah Jenis Paket
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <ModalPackingSettings
      ref="modalPackingSettings"
      :fetcher="fetcherPackingMaterials"
      @on-save="handleSavePackingMaterials"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { newAxiosIns } from '@/libs/axios'
import filters from '@/libs/filters'
import InfiniteSelect from '@/views/components/select/InfiniteSelect.vue'
import PackingSelection from './PackingSelection.vue'
import ModalPackingSettings from './ModalPackingSettings.vue'
import createRecalculation from '../composables/useRecalculation'
import usePackingMaterialsFetcher from '../composables/usePackingMaterialsFetcher'
import useProductManagements from '../composables/useProductManagements'

export default {
  components: {
    vSelect,
    // BulkUploadComponent: () => import('./BulkUploadComponent.vue'),
    PackingSelection,
    ModalPackingSettings,
    InfiniteSelect,
  },
  filters: { rupiah: filters.rupiah },
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
    fetcherWarehouses: {
      type: Object,
      default: () => undefined,
    },
    listWarehouses: {
      type: Object,
      default: () => ({
        isLoading: true,
        isError: false,
        data: [],
      }),
    },
    usedWarehouses: {
      type: Array,
      default: () => [],
    },
    backButton: {
      type: Boolean,
      default: false,
    },
    packings: {
      type: Object,
      default: () => ({
        options: [],
        optionsObj: {},
      }),
    },
    isAllowedForBulkUpload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      file1: null,
      confirmButton: true,
      tempWarehouse: null,
      warehouse: null,
      isPacketContentUpdated: false,

      packetContentOption: [],

      packetType: [],

      loading: false,

      file: null,
      rawProductsCache: [],
      bulkDataShown: false,
      isUploadingLabel: false,
      isFetchingProductWarehouse: false,

      fetcher: null,

      packingMaterialsFetcher: null,
      productManagementsFetcher: null,
    }
  },
  computed: {
    fetcherPackingMaterials() {
      return this.packingMaterialsFetcher?.state?.fetcher
    },
    productManagementsData() {
      return this.productManagementsFetcher?.state?.fetcher?.data || []
    },
    productManagementsHasMore() {
      return this.productManagementsFetcher?.state?.fetcher?.hasMore || false
    },
    productManagementsLoading() {
      return this.productManagementsFetcher?.state?.fetcher?.loading || false
    },
    enableForContentAddition() {
      return this.rawProductsCache.length > 0
          && !this.isFetchingProductWarehouse
          && this.file1
          && this.packings.options.length > 0
    },
    warehouseOptions() {
      const data = this.fetcherWarehouses?.data
      if (!data || !Array.isArray(data)) return []

      const usedWarehousesSet = new Set(this.usedWarehouses)
      const seen = new Set()
      const tempWarehouseName = this.tempWarehouse?.name

      return data.reduce((acc, warehouse) => {
        if (!warehouse) return acc

        const warehouseId = warehouse.id
        if (warehouseId !== undefined && warehouseId !== null) {
          if (seen.has(warehouseId)) {
            return acc
          }
          seen.add(warehouseId)
        }

        acc.push({
          ...warehouse,
          disabled: usedWarehousesSet.has(warehouse.name) && warehouse.name !== tempWarehouseName,
        })
        return acc
      }, [])
    },
    calculatedTotalOrder() {
      return this.packetType.reduce((acc, obj) => {
        const valueToAdd = obj.total !== null && obj.total !== undefined ? obj.total : 0
        return acc + valueToAdd
      }, 0)
    },
    calculatedGrandTotalCost() {
      return this.packetType.reduce((acc, order) => {
        if (order.total_fulfillment_cost) {
          return acc + order.total_fulfillment_cost
        }
        return order.packetContent.reduce((acc2, packet) => acc2 + packet.contentTotalCost)
      }, 0)
    },
    calculatedGrandKompackRevenue() {
      return this.packetType.reduce((acc, order) => acc + (order?.total_kompack_revenue || 0), 0)
    },
  },
  watch: {
    tempWarehouse: {
      async handler(newValue, oldValue) {
        if (this.isWarehouseReverted) {
          this.isWarehouseReverted = false
          return
        }
        if (newValue === oldValue) return

        if ((this.$refs.bulkUploadComponent && this.$refs.bulkUploadComponent.hasItems) || this.isPacketContentUpdated) {
          await this.handleWarehouseChange(newValue, oldValue)
          return
        }
        this.warehouse = newValue
      },
    },
    warehouse: {
      async handler(newValue, oldValue) {
        if (this.isWarehouseReverted) {
          this.isWarehouseReverted = false
          return
        }
        if (!newValue) return
        try {
          this.$emit('selected-warehouse', newValue)
          this.packetContentOption = []
          if (this.productManagementsFetcher?.state?.fetcher) {
            await this.productManagementsFetcher.state.fetcher.fetchData({ reset: true, options: { warehouseId: newValue.id } })
            const productWarehouse = this.productManagementsFetcher.state.fetcher.data
            if (!productWarehouse || productWarehouse.length === 0) {
              this.revertWarehouseSelection(oldValue, newValue)
              return
            }
            this.packetContentOption = productWarehouse
            this.confirmButton = false
            if (this.fetcherPackingMaterials) {
              this.fetcherPackingMaterials.fetchData({ reset: true, options: { warehouseId: newValue.id } })
            }
          }
        } catch (error) {
          this.$toast_error({
            message: 'Gagal mengambil data produk gudang, silahkan coba lagi',
          })
          this.revertWarehouseSelection(oldValue, newValue)
        }
      },
    },
  },
  created() {
    this.packetContentMap = new Map()
    this.kompackCost = undefined
    this.isWarehouseReverted = false
    this.recalculation = createRecalculation(this)
    this.packingMaterialsFetcher = usePackingMaterialsFetcher(this)
    this.productManagementsFetcher = useProductManagements(this)
  },
  mounted() {
    if (this.packingMaterialsFetcher) {
      this.packingMaterialsFetcher.initializeFetcherPackingMaterials()
    }
    if (this.productManagementsFetcher) {
      this.productManagementsFetcher.initializeFetcherProductInWarehouse()
    }
  },
  beforeMount() {
    this.setOrEmptyPacketType(true)
  },
  unmounted() {
    this.packetContentMap.clear()
  },
  methods: {
    handleSearchWarehouse(query) {
      this.fetcherWarehouses.fetchData({ reset: true, options: { search: query } })
    },
    onSearchProduct(query) {
      if (this.productManagementsFetcher?.state?.fetcher && this.warehouse?.id) {
        this.productManagementsFetcher.state.fetcher.fetchData({ reset: true, options: { warehouseId: this.warehouse.id, search: query } })
      }
    },
    onIntersectProduct() {
      if (this.productManagementsFetcher?.state?.fetcher) {
        this.productManagementsFetcher.state.fetcher.fetchData()
      }
    },
    /**
     * Reverts the current warehouse selection to the previous value when downstream fetching fails.
     */
    revertWarehouseSelection(previousWarehouse, newWarehouse) {
      this.$emit('revert-warehouse', newWarehouse, previousWarehouse)
      this.isWarehouseReverted = true
      this.tempWarehouse = previousWarehouse
      this.isWarehouseReverted = true
      this.warehouse = previousWarehouse
    },
    /**
     * Ensures the dropdown escapes overflow containers by positioning it relative to the body.
     */
    positionDropdown(dropdownList, component, { width }) {
      const dropdownEl = dropdownList
      dropdownEl.style.width = width
      const {
        top,
        left,
        height,
      } = component.$el.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
      dropdownEl.style.left = `${left + scrollLeft}px`
      dropdownEl.style.top = `${top + height + scrollTop}px`
    },
    handleSavePackingMaterials(data) {
      this.packetType[data.position].packings = data.data
    },
    /**
     * Handles the edit packing materials. Summon the modal packing settings to edit the packing materials.
     * @param packet {Object} - The packet object to edit the packing materials.
     * @param position {Number} - The position of the packet to edit the packing materials.
     */
    handleEditPacking(packet, position) {
      const { packings } = packet
      this.$refs.modalPackingSettings.show({
        position,
        packings,
      })
    },
    /**
     * Updates the packet content.
     * @param packetArg {Object} - The packet object to update the content.
     * @param itemArg {Object} - The item object to update the content.
     */
    updatePacketContent(packetArg, itemArg) {
      const packet = packetArg
      const item = itemArg

      if (!item.option) {
        return
      }

      packet.total = null
      item.variants = {}
      item.amount = 1
      if (item.option.is_bundling) {
        item.totalVariant = item.option.variants.reduce((total, product) => total + product.qty, 0)
      } else {
        item.totalVariant = 1
      }
      item.contentTotalCost = 0
      this.isPacketContentUpdated = true
      this.setPacketPackings(packet, item)
    },
    /**
     * Handles the content is updated.
     */
    handleContentIsUpdated(data) {
      this.$emit('form-is-updated', {
        title: this.warehouse?.name || '',
        warehouse: this.warehouse,
        completed: data.completed,
        totalOrder: data.totalOrder || this.calculatedTotalOrder,
        fulfillmentCost: data.fulfillmentCost || this.calculatedGrandTotalCost,
      })
      if (data.status === 'shown') {
        this.bulkDataShown = true
      }
    },
    /**
     * Handles the packet change.
     */
    handlePacketChange() {
      this.isPacketContentUpdated = true
    },
    /**
     * Handles the edit packet.
     */
    handleEditPacket(packet) {
      this.$set(packet, 'saved', false)
      this.updateProductMap(packet, 'increase')
      this.handleContentIsUpdated({
        completed: false,
      })
    },
    /**
     * Handles the submission of content.
     */
    async handleSubmitContent() {
      if (this.bulkDataShown) {
        if (!this.$refs.bulkUploadComponent) {
          return {
            success: false,
            section: 'submitPacking',
            reason: 'component_not_found',
            payload: {
              outbound_id: null,
              file: null,
            },
          }
        }
        return this.$refs.bulkUploadComponent.handleSubmitBulkUpload(this.file1)
      }
      return this.submitPacking()
    },
    /**
       * Update the available stock for a variant
       *
       * @param {Object} item - The item object containing the variant
       * @param {number} index2 - The index of the bundling
       * @param {number} qty - The quantity of the variant
       */
    updateAvailable(item, index2, qty) {
      const { variants } = item.option
      const variantIndex = this.getBundlingVariantIndex(variants, index2, qty)
      const lastVariant = item.variants[variantIndex]

      const lastData = this.packetContentMap.get(`${lastVariant.product_id}&${lastVariant.id}`)
      const variant = !lastData ? lastVariant : {
        ...lastVariant,
        qty,
        available: lastData.available,
        usedStock: lastData.usedStock,
      }

      if (lastData) {
        this.$set(item.variants, variantIndex, variant)
      }

      this.setMaxAmount(item, item.variants)
    },
    /**
       * Calculate the correct variant index for bundling products
       * This fixes the bug where qty > 6 causes wrong variant selection
       *
       * @param {Array} variants - Array of all bundling variants
       * @param {number} bundlingIndex - Current bundling index (index2)
       * @param {number} qtyIndex - Current quantity index (qty)
       * @returns {number} Correct variant index
       */
    getBundlingVariantIndex(variants, bundlingIndex, qtyIndex) {
      let cumulativeIndex = 0

      // Sum up quantities of all previous bundlings
      for (let i = 0; i < bundlingIndex; i += 1) {
        cumulativeIndex += variants[i].qty
      }

      // Add current quantity index (minus 1 because qty starts from 1)
      cumulativeIndex += qtyIndex - 1

      return cumulativeIndex
    },
    async handleRecalculation(packet, index) {
      const currentPacket = packet
      currentPacket.isLoading = true
      const result = await this.recalculation.recalculateFulfillment(packet)
      if (result.success) {
        currentPacket.total_fulfillment_cost = result.data.grand_fulfillment_cost
        currentPacket.fulfillment_cost = result.data.fulfillment_cost
        currentPacket.total_kompack_revenue = result.data.grand_kompack_revenue
        currentPacket.storage_cost = result.data.storage_cost
        currentPacket.packing_cost = result.data.packing_cost
        currentPacket.saved = true
        currentPacket.order = index + 1
        this.kompackCost = result.data.kompack_revenue
        this.updateProductMap(currentPacket, 'reduce')
        this.handleContentIsUpdated({
          completed: this.warehouse && this.file1 && !this.somePacketTypeNotSaved(),
        })
      }
      currentPacket.isLoading = false
    },
    /**
     * Tell that the packet is updated to parent component.
     */
    tellThatPacketIsUpdated() {
      this.handleContentIsUpdated({
        completed: this.warehouse && this.file1 && !this.somePacketTypeNotSaved(),
      })
    },
    /**
       * Sets the packings field for a given packet and remove duplicate packing material.
       *
       * @param {Object} packet - The packet object to set packings for.
       */
    setPacketPackings(packet, item) {
      const currentPacket = packet

      const mappedPackings = currentPacket.packetContent.reduce(
        (acc, content) => {
          (content.option?.packings || []).forEach(packing => {
            const packingId = packing.id
            if (acc.indexMap.has(packingId)) {
              const existingIndex = acc.indexMap.get(packingId)
              acc.packings[existingIndex].layer = 1
            } else {
              acc.packings.push({ ...packing })
              const newIndex = acc.packings.length - 1
              acc.indexMap.set(packingId, newIndex)
            }
          })
          return acc
        },
        { packings: [], indexMap: new Map() },
      )

      currentPacket.packings = mappedPackings.packings
    },
    removeSameVariant(items) {
      const uniqueItems = []
      const seen = new Set()

      items.forEach(item => {
        const { amount, ...itemWithoutAmount } = item
        const identifier = Object.values(itemWithoutAmount.variants).map(variant => `${variant.product_id}&${variant.id}`).join(',')
        if (!seen.has(identifier)) {
          seen.add(identifier)
          uniqueItems.push(item)
        }
      })

      // eslint-disable-next-line no-param-reassign
      items.length = 0
      uniqueItems.forEach(item => { items.push(item) })
    },
    previewFile() {
      const reader = new FileReader()

      reader.onload = e => {
        const pdfData = e.target.result

        const newTab = window.open()
        newTab.document.body.innerHTML = `<embed width="100%" height="100%" src="${pdfData}" type="application/pdf" />`
      }

      reader.readAsDataURL(this.file1)
    },
    formatNumber(value) {
      return value ? value.replace(/[^\d]/g, '').slice(0, 7) : value
    },
    setOrEmptyPacketType(set) {
      const emptyPacket = {
        order: null,
        total: null,
        packetContent: [
          {
            amount: null,
            option: null,
            totalVariant: 0,
            contentTotalCost: 0,
            product_variant_id: 0,
            variants: {},
          },
        ],
        saved: false,
        maxTotal: 0,
        total_fulfillment_cost: 0,
        packings: [],
        isLoading: false,
      }

      this.packetType = set ? [emptyPacket] : [...this.packetType, emptyPacket]
    },
    pushEmptyPacketContent(packet, index) {
      packet.packetContent.push({
        amount: null,
        option: null,
        totalVariant: 0,
        contentTotalCost: 0,
        product_variant_id: 0,
        variants: {},
      })
    },
    addPacketContentDisabled(packet) {
      return packet.packetContent.some(item => !item.variants
        || !item.amount
        || !item.amount === ''
        || Object.keys(item.variants).some(key => item.variants[key] === null)
        || Object.keys(item.variants).length !== item.totalVariant) || !packet.packings
    },
    editPackagingDisabled(packet) {
      return packet.saved
        || !packet.total
        || this.confirmButton
        || this.addPacketContentDisabled(packet)
    },
    somePacketTypeNotSaved() {
      return this.packetType.some(packet => !packet.saved)
    },
    async submitPacking() {
      this.loading = true
      const mappedPackages = this.packetType.map((item, index) => ({
        order_list: item.order,
        total_order: item.total,
        fulfillment_fee: item.fulfillment_cost,
        kompack_revenue: item.total_kompack_revenue,
        storage_cost: item.storage_cost,
        packing_cost: item.packing_cost,
        packings: item.packings,
        products: item.packetContent.map(packet => {
          const product = {
            total_item: packet.amount,
            product_id: packet.option.value,
            product_name: packet.option.label,
            product_variant_id: 0,
            variant_name: '',
            is_bundling: packet.option.is_bundling,
            product_bundles: [],
            product_fulfillment: packet.option.fulfillment_cost,
            is_product_bonus: packet.option.is_product_bonus,
          }

          if (packet.option.is_bundling) {
            product.product_variant_id = 0
            product.variant_name = ''
            product.product_bundles = Object.values(packet.variants).map(variant => ({
              product_id: variant.product_id,
              product_name: variant.name.split(' : ')[0],
              product_variant_id: variant.id,
              variant_name: variant.name,
              qty: 1,
              is_product_bonus: variant.is_product_bonus,
            }))
          } else {
            product.product_variant_id = packet.option.is_variant ? packet.variants[0].id : 0
            product.variant_name = packet.option.is_variant ? packet.variants[0].name : ''
          }

          return product
        }),
      }))

      const { mitra_id, id: warehouse_id } = this.warehouse

      const payload = {
        kompack_tech_cost: this.kompackCost,
        grand_kompack_revenue: this.calculatedGrandKompackRevenue,
        grand_fulfillment_fee: this.calculatedGrandTotalCost,
        grand_total_order: this.calculatedTotalOrder,
        mitra_id,
        packages: mappedPackages,
        warehouse_id,
      }

      try {
        const { data } = await newAxiosIns.post('/kompack/api/v1/outbounds', payload)
        if (data.meta.code === 201) {
          return {
            success: true,
            section: 'submitPacking',
            payload: {
              outbound_id: data.data.outbound_id,
              file: this.file1,
            },
          }
        }
      } catch (error) {
        if (error.response.data.meta && error.response.data.meta.message === 'insufficient user balance') {
          return {
            success: false,
            section: 'submitPacking',
            reason: 'insufficient_balance',
            payload: {
              outbound_id: null,
              file: null,
            },
          }
        }
        return {
          success: false,
          section: 'submitPacking',
          reason: 'failed_to_submit',
          payload: {
            outbound_id: null,
            file: null,
          },
        }
      } finally {
        this.loading = false
      }

      return {
        success: false,
        section: 'submitPacking',
        reason: 'failed_to_submit',
        payload: {
          outbound_id: null,
          file: null,
        },
      }
    },
    handleBulkDataSuccess(bulkDataSubmitResponse) {
      const { outbound_id } = bulkDataSubmitResponse.data
      this.isUploadingLabel = true
      const formData = new FormData()
      formData.append('label', this.file1)

      newAxiosIns.put(`/kompack/api/v1/outbounds/${outbound_id}/label`, formData)
        .then(() => {
          this.$swal({
            title: 'Pengajuan Packing Berhasil',
            text: 'Pengajuan packing akan segera diproses oleh mitra gudang',
            icon: 'success',
            iconHtml: '<img src="https://storage.googleapis.com/komerce/core/icon-popup-success.png">',
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'Selesai',
            customClass: {
              icon: 'border-0 mb-[16px]',
              confirmButton: 'btn btn-primary w-full',
            },
            buttonsStyling: false,
          }).then(result => {
            if (result.value) {
              this.$router.push({
                path: '/history-pickup',
              })
            }
          })
        })
        .catch(err => {
          this.$toast.error('Pengajuan packing gagal diajukan')
        })
        .finally(() => {
          this.isUploadingLabel = false
        })
    },
    async handleWarehouseChange(newValue, oldValue) {
      await this.$nextTick()
      const popup = await this.$swal({
        title: 'Konfirmasi Ubah Gudang',
        html: '<span class="text-[#626262]">Data orderan yang sudah diinput akan hilang jika kamu ganti gudang. Tetap ubah pilihan gudang?</span>',
        icon: 'warning',
        iconHtml: '<img src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png">',
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: 'Batal',
        confirmButtonText: 'Ubah Gudang',
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          popup: '!max-w-[620px] !w-full text-[#626262]',
          title: 'mb-1',
          icon: 'border-0 mb-[16px] size-[92px]',
          actions: 'flex flex-row flex-wrap gap-2',
          confirmButton: 'btn btn-primary grow',
          cancelButton: 'btn btn-outline-primary grow',
        },
        buttonsStyling: false,
      })

      if (popup.isConfirmed) {
        if (this.$refs.bulkUploadComponent) {
          this.$refs.bulkUploadComponent.handleDeleteAll()
        }
        this.setOrEmptyPacketType(true)
        this.warehouse = newValue
        this.packetContentMap.clear()
        return
      }

      this.isWarehouseReverted = true
      this.tempWarehouse = oldValue
    },
    /**
     * Check if the variant is selectable based on stock and used stock
     * @param option {Object} - The option object
     * @param qty {number} - The quantity
     * @returns {boolean} - Whether the variant is selectable
     */
    checkIsSelectableVariant(option, qty = 0) {
      const lastData = this.packetContentMap.get(`${option.product_id}&${option.id}`)
      const stock = lastData?.stock || option.stock
      const usedStock = lastData?.usedStock || option.usedStock || 0
      return (stock - usedStock) / qty >= 1
    },
    /**
     * Update the product map so we can use it to check if the stock is enough based on last operation
     * @param packet {Object} - The packet object
     * @returns {void}
     */
    updateProductMap(packet, type) {
      packet.packetContent.forEach(item => {
        Object.values(item.variants).forEach(variant => {
          const usedStock = variant.qty * item.amount * packet.total
          const newVariantData = {
            ...variant,
            available: item.available,
            usedStock: type === 'reduce' ? (variant.usedStock || 0) + usedStock : (variant.usedStock || 0),
          }
          this.packetContentMap.set(`${variant.product_id}&${variant.id}`, newVariantData)
        })
      })
    },
    /**
     * Set the maximum amount of the item
     * @param item {Object} - The item object
     * @param variants {Array} - The variants array
     * @returns {void}
     */
    setMaxAmount(item, variants) {
      const availableItems = Object.values(variants).map(variant => (((variant.stock - (variant.usedStock || 0)) / (item.amount || 1)) / variant.qty))
      const minAvailable = Math.min(...availableItems)
      const available = Math.floor(minAvailable)

      this.$set(item, 'available', available)
    },
    /**
     * Handle the last item removal to clear the packet content map
     */
    handleLastItemRemoval() {
      if (this.packetType.length === 1) {
        this.packetContentMap.clear()
      }
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
